module.exports = __webpack_public_path__ + "static/media/checkoff.dc0dd935.svg";